import React, { useState, useEffect } from 'react';
import '../../../App.scss';
import 'antd/dist/antd.css';
import { PageHeader } from 'antd';

import AdminStatusClientsBody from './AdminStatusClientsBody';

export default function AdminPausedClientsScreen({ locStrings, isAdmin }) {
    return (
        <div>
            <PageHeader title="Paused Clients" />
            <AdminStatusClientsBody status="paused" locStrings={locStrings} isAdmin={isAdmin} />
        </div>
    );
}
